import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-text-cell',
  templateUrl: './text-cell.component.html',
  styleUrls: ['./text-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextCellComponent {
  @Input() text: string;
}
